


















import Vue from 'vue';

import TheMenu from './components/TheMenu.vue';
import TheMap from './components/TheMap.vue';
import TheSnackbar from './components/TheSnackbar.vue';

export default Vue.extend({
  components: {
    TheMenu,
    TheMap,
    TheSnackbar,
  },
});
